module.exports = __webpack_public_path__ + "media/snowflakes.6688cec6.mp4";